import React from 'react';
import { Link } from 'react-router-dom';
import { fmtMoney } from '../../utils/money';
import PaymentBadge from './PaymentBadge';

// الغلاف: يسرد المشاريع وحالة سدادها؛ كل صف رابط لتفصيل المشروع.
export default function OverallSummaryTable({ summary, funderId, month }) {
  const funded = summary?.funded_projects || [];
  const pending = summary?.pending_projects || [];
  const totals = summary?.totals || {};
  const projectLink = (id) => `/financial-reports/${funderId}/${month}/projects/${id}`;

  return (
    <>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title" style={{ marginBottom: 12 }}>المشاريع المموَّلة ({funded.length})</div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>المشروع</th>
                <th>إجمالي التمويل</th>
                <th>المستهلَك</th>
                <th>المتبقّي</th>
                <th>حالة السداد</th>
                <th>المدفوع</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {funded.length === 0 && (
                <tr><td colSpan={7} className="empty">لا مشاريع مموَّلة في هذا الشهر</td></tr>
              )}
              {funded.map((p) => (
                <tr key={p.id}>
                  <td style={{ fontWeight: 600 }}>
                    <Link to={projectLink(p.id)}>{p.name}</Link>
                    {p.unit_basis && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{p.unit_basis} · {p.contracts_count} عقد</div>}
                    {p.has_alerts && <span className="badge badge-pending" style={{ marginInlineStart: 6 }}>⚠ تنبيهات</span>}
                  </td>
                  <td>{fmtMoney(p.funding_total)}</td>
                  <td>
                    {fmtMoney(p.total_used)}
                    {p.monthly_change > 0 && (
                      <div style={{ fontSize: 11, color: 'var(--success)' }}>+{fmtMoney(p.monthly_change)} هذا الشهر</div>
                    )}
                  </td>
                  <td>{fmtMoney(p.total_remaining)}</td>
                  <td>
                    <PaymentBadge status={p.payment_status} />
                    {p.payment_status === 'paid_partial' && (
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                        المدفوع {fmtMoney(p.paid_amount)} · المتبقّي {fmtMoney(p.funding_total - p.paid_amount)}
                      </div>
                    )}
                  </td>
                  <td>{fmtMoney(p.paid_amount)}</td>
                  <td><Link className="btn btn-sm btn-outline" to={projectLink(p.id)}>تفصيل ←</Link></td>
                </tr>
              ))}
            </tbody>
            {funded.length > 0 && (
              <tfoot>
                <tr style={{ fontWeight: 700, background: 'var(--surface-alt)' }}>
                  <td>الإجمالي</td>
                  <td>{fmtMoney(totals.funding_total)}</td>
                  <td>{fmtMoney(totals.total_used)}</td>
                  <td>{fmtMoney(totals.total_remaining)}</td>
                  <td></td>
                  <td>{fmtMoney(totals.paid_amount)}</td>
                  <td></td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {pending.length > 0 && (
        <div className="card" style={{ marginBottom: 16, borderInlineStart: '4px solid var(--info)' }}>
          <div className="card-title" style={{ marginBottom: 8 }}>
            مبالغ معتمدة بانتظار التمويل
            <span style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 400 }}> — لا تدخل مجاميع المموَّل</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>المشروع</th><th>المبلغ المعتمد</th><th>الحالة</th></tr></thead>
              <tbody>
                {pending.map((p) => (
                  <tr key={p.id}>
                    <td style={{ fontWeight: 600 }}>{p.name}</td>
                    <td>{fmtMoney(p.approved_amount)}</td>
                    <td><PaymentBadge status={p.payment_status} /></td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700, background: 'var(--surface-alt)' }}>
                  <td>إجمالي المعتمد</td>
                  <td>{fmtMoney(totals.pending_total)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
